<div class="calendar-box" [ngClass]="{'mini': mini}">
  <div class="date-component">{{ dateComponent }}</div>
  <div class="month-component">{{ monthComponent }}</div>
</div>
